import { useState } from 'react'

import { Button, IllustrationType } from '@factorialco/deprecated-design-system'
import {
  EmployeeForSelectFragment,
  ProjectManagementProjectEmployeesAssignmentEnum,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import EmployeeAssignmentSelector from 'modules/project_management/components/EmployeeAssignmentSelector'

export interface AssignEmployeesSingeProjectModalProps {
  onClose: () => void
  onSubmit: (
    oldEmployeesAssignment: string,
    newEmployeesAssignment: string,
    selectedEmployees: number[]
  ) => Promise<void>
  loading: boolean
  title: string
  description: string
  iconName: IllustrationType
  initialAssignedEmployees: EmployeeForSelectFragment[]
  submitButton: string
  employeesAssignment: ProjectManagementProjectEmployeesAssignmentEnum
}

const AssignEmployeesSingleProjectModal = ({
  onClose,
  onSubmit,
  loading,
  title,
  description,
  iconName,
  initialAssignedEmployees,
  submitButton,
  employeesAssignment,
}: AssignEmployeesSingeProjectModalProps) => {
  const [selectedEmployees, setSelectedEmployees] = useState<EmployeeForSelectFragmentNoAccess[]>(
    employeesAssignment === 'manual' ? initialAssignedEmployees : []
  )

  const [assignmentSelection, setAssignmentSelection] =
    useState<ProjectManagementProjectEmployeesAssignmentEnum>(employeesAssignment)

  const isManualSelected = assignmentSelection === 'manual'

  const toggleAssignmentSelection = (value: ProjectManagementProjectEmployeesAssignmentEnum) => {
    setAssignmentSelection(value)
  }

  const onSelectEmployees = (newEmployees: EmployeeForSelectFragmentNoAccess[]) => {
    setSelectedEmployees(newEmployees)
  }

  const submitModal = () => {
    onSubmit(
      employeesAssignment,
      assignmentSelection,
      selectedEmployees.map((employee) => employee.id)
    )
  }

  const disableSubmitButton = () => {
    return (isManualSelected && !selectedEmployees.length) || loading
  }

  return (
    <Modal
      illustration={iconName}
      title={title}
      description={description}
      onClose={onClose}
      onSubmit={submitModal}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={disableSubmitButton()} submit>
            {submitButton}
          </Button>
        </>
      }
    >
      <EmployeeAssignmentSelector
        isManualSelected={isManualSelected}
        onSelectEmployees={onSelectEmployees}
        selectedEmployees={selectedEmployees}
        toggleAssignmentSelection={toggleAssignmentSelection}
      />
    </Modal>
  )
}

export default observer(AssignEmployeesSingleProjectModal)
